import { render, staticRenderFns } from "./privacy-modal.vue?vue&type=template&id=6b58d3db&"
import script from "./privacy-modal.vue?vue&type=script&lang=ts&"
export * from "./privacy-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports